import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { AnimatePresence, motion } from "framer-motion";

export default function Industries({ expert_id, hideNumber, setExistIndustry, setHasIndustry }) {
  const [expertIndustryList, setExpertIndustryList] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [showAddIndustry, setShowAddIndustry] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [showMore, setShowMore] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const filteredIndustries = industries.filter(ind =>
    ind.toLowerCase().includes(selectedIndustry.toLowerCase())
  );

  function fetchSectorData() {
    const token = localStorage.getItem("AccessToken");
    fetch(`${API_URL}get-expert-profile-industries/${expert_id}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        setExpertIndustryList(data.expertIndustries);
        setDataFetched(true);
        if (data.expertIndustries.length > 0) {
          setHasIndustry(true);}
        })
      .catch(console.error);
  }

  useEffect(() => { fetchSectorData(); }, []);

  const removeSectorHandler = (expertID, sectorName) => {
    const token = localStorage.getItem("AccessToken");
    setReturnError(false);
    setLoading(true);
    fetch(`${API_URL}remove-expert-sector/${expertID}/${sectorName}`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.status === "success") {
          fetchSectorData();
          setReturnSuccess(true);
          setTimeout(() => setReturnSuccess(false), 1500);
        } else {
          setReturnError(true);
          setTimeout(() => setReturnError(false), 1500);
        }
      })
      .catch(err => {
        setLoading(false);
        setReturnError(true);
        console.error(err);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("AccessToken");
    fetch(`${API_URL}get-all-industries`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(data => setIndustries(data.industryList))
      .catch(console.error);
  }, []);

  const handleSaveSelectedIndustry = (value) => {
    const token = localStorage.getItem("AccessToken");
    setReturnError(false);
    setLoading(true);
    fetch(`${API_URL}update-expert-industries/${expert_id}`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ industry: value }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          fetchSectorData();
          setTimeout(() => {
            setLoading(false);
            setReturnSuccess(true);
          }, 500);
          setTimeout(() => setReturnSuccess(false), 2000);
          setSelectedIndustry("");
        } else {
          setLoading(false);
          setReturnError(true);
          setTimeout(() => setReturnError(false), 1500);
        }
      })
      .catch(err => {
        setLoading(false);
        setReturnError(true);
        setTimeout(() => setReturnError(false), 1500);
        console.error(err);
      });
  };

  return (
    <div className={`bg-white rounded-xl p-6 relative transition-all duration-300 ${showAddIndustry ? "glow-burst glow-hold" : "shadow"}`}>
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold mb-2">{!showAddIndustry ? 'Industries' : 'Add Industry'}</h3>
        <button
          className={`absolute top-5 right-6 text-gray-500 hover:text-black hover:bg-gray-200 py-1 ${showAddIndustry ? "px-2.5" : "px-2"} rounded-full transition focus:outline-none`}
          onClick={() => setShowAddIndustry(!showAddIndustry)}
          title={showAddIndustry ? "Cancel" : "Edit Industries"}
        >
          <i className={`fa-solid ${showAddIndustry ? "fa-xmark" : "fa-pencil"}`} />
        </button>
      </div>

      <AnimatePresence mode="wait">
        {!showAddIndustry ? (
          <motion.div
            key="industries-view"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div>
              {dataFetched && (
                expertIndustryList.length === 0 ? (
                  <span className="text-gray-500">No industries added yet</span>
                ) : (
                  <>
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={showMore ? "expanded" : "collapsed"}
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        className="overflow-hidden mb-4"
                      >
                        {(showMore ? expertIndustryList : expertIndustryList.slice(0, 6)).map((industry, index) => (
                          <span key={index} className="chip bg-[#365561] text-white pt-1 pb-1 px-2 mr-0 mb-0 inline-block rounded-full" style={{ backgroundColor: "#365561"}}>
                            {`${industry.industryName}${industry.count > 1 ? ` (${industry.count})` : ""}`}
                            <i
                              className="fa-solid fa-xmark cursor-pointer text-xs ml-2 hover:text-red-500 transition duration-300"
                              onClick={() => removeSectorHandler(industry.expertID, industry.industryName)}
                              title="Remove Industry"
                            />
                          </span>
                        ))}
                      </motion.div>
                    </AnimatePresence>
                    {expertIndustryList.length > 6 && (
                      <div className="absolute left-1/2 bottom-5 transform -translate-x-1/2 translate-y-1/2">
                        <button
                          onClick={() => setShowMore(!showMore)}
                          className="text-gray-600 hover:text-blue-600 transition duration-300 focus:outline-none flex flex-row gap-2 items-center"
                        >
                          <motion.i
                            className="fa-solid fa-chevron-down text-md"
                            animate={{
                              rotate: showMore ? 180 : 0,
                              scale: [1, 1.2, 1],
                            }}
                            transition={{
                              duration: 0.4,
                              ease: "easeInOut",
                            }}
                          />
                          <motion.p
                            key={showMore ? "less" : "more"}
                            initial={{ opacity: 0, y: 5 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -5 }}
                            transition={{ duration: 0.3 }}
                            className="text-sm"
                          >
                            {showMore ? "view less" : "view more"}
                          </motion.p>
                        </button>
                      </div>
                    )}
                  </>
                )
              )}
            </div>
          </motion.div>
        ) : (
          <motion.div
            key="industries-edit"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="relative mb-3">
              {expertIndustryList.map((industry, index) => (
                <span key={index} className="chip bg-[#365561] text-white pt-1 pb-1 px-2 mr-0 mb-0 inline-block rounded-full" style={{ backgroundColor: "#365561"}}>
                  {`${industry.industryName}${industry.count > 1 ? ` (${industry.count})` : ""}`}
                  <i
                    className="fa-solid fa-xmark cursor-pointer text-xs ml-2 hover:text-red-500 transition duration-300"
                    onClick={() => removeSectorHandler(industry.expertID, industry.industryName)}
                    title="Remove Industry"
                  />
                </span>
              ))}
            </div>
            {/* Animated Autocomplete Dropdown */}
            <div className="w-full mt-2">
              <input
                type="text"
                placeholder="Type an industry"
                value={selectedIndustry}
                onChange={(e) => setSelectedIndustry(e.target.value)}
                onFocus={() => setShowDropdown(true)}
                onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
                className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-1 bg-white"
              />

              <AnimatePresence>
                {showDropdown && selectedIndustry.length > 0 && filteredIndustries.length > 0 && (
                  <motion.ul
                    key="dropdown"
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.2 }}
                    className="autocomplete-scroll absolute z-10 w-[90%] bg-white border border-gray-200 rounded-md shadow-md mt-1 max-h-48 overflow-x-hidden"
                  >
                    {filteredIndustries.map((ind, index) => (
                      <motion.li
                        key={index}
                        className={`px-3 py-1 text-sm cursor-pointer select-none list-none ${
                          index === highlightedIndex
                            ? "bg-gray-100"
                            : "hover:bg-gray-100"
                        }`}
                        onMouseDown={() => {
                          setSelectedIndustry(ind);
                          setShowDropdown(false);
                        }}
                        whileHover={{ scale: 1.02 }}
                      >
                        {ind}
                      </motion.li>
                    ))}
                  </motion.ul>
                )}
              </AnimatePresence>
            </div>

            <button
              className={`text-blue-600 text-xs hover:underline mt-1 ${
                selectedIndustry ? "animate-pulse text-blue-700 font-semibold" : ""
              }`}
              onClick={() => {
                if (!selectedIndustry) return;
                handleSaveSelectedIndustry(selectedIndustry);
                setSelectedIndustry("");
              }}
            >
              + Add
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {loading && <img className="absolute bottom-3 right-4 h-5" src={LoadingIcon} alt="loading" title="Loading..." />}
      {returnSuccess && <img className="absolute bottom-3 right-4 h-5" src={successIcon} alt="success" title="Success" />}
      {returnError && <img className="absolute bottom-3 right-4 h-5" src={errorIcon} alt="error" title="Error" />}

      <style>{`
        @keyframes glowBurst {
          0% { box-shadow: 0 0 0px 0px rgba(54, 85, 97, 0); }
          30% { box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6); }
          100% { box-shadow: 0 0 15px 3px rgba(54, 85, 97, 0.6); }
        }
        .glow-burst { animation: glowBurst 0.8s ease-out forwards; border-radius: 0.75rem; }
        .glow-hold { box-shadow: 0 0 20px 6px rgba(54, 85, 97, 0.6); border-radius: 0.75rem; }
        
        // .skill-div {
        //   display: flex;
        //   flex-wrap: wrap;
        //   gap: 8px; /* adds spacing between chips */
        // }

        // .skill-span {
        //   display: inline-flex;
        //   align-items: center;
        //   padding: 6px 10px;
        //   border-radius: 9999px; /* full pill shape */
        //   background-color: #365561;
        //   color: white;
        //   font-size: 0.875rem;
        //   line-height: 1.25rem;
        // }

        // .skill-span i {
        //   margin-left: 8px;
        //   transition: color 0.2s ease, transform 0.2s ease;
        //   cursor: pointer;
        // }

        // .skill-span i:hover {
        //   color: #ef4444;
        //   transform: scale(1.15);
        // }

        .chip {
          display: inline-flex;
          align-items: center;
          padding: 6px 10px;
          margin: 4px;              /* This is key for spacing */
          border-radius: 9999px;
          font-size: 0.75rem;
          background-color: #365561;
          color: white;
        }
      `}</style>
    </div>
  );
}